import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Coins } from "lucide-react";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@coins.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] grid place-items-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-3 mb-12" data-testid="login-logo-link">
          <Coins className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.5} />
          <span className="font-display text-2xl text-[#F3EFE0]">Cornett Coins &amp; Collectibles</span>
        </Link>
        <div className="coin-tag mb-3">Restricted Access</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter mb-10">The Curator&apos;s Entrance</h1>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="coin-tag block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-b border-[#F3EFE0]/20 focus:border-[#D4AF37] outline-none py-3 text-[#F3EFE0]"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="coin-tag block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-[#F3EFE0]/20 focus:border-[#D4AF37] outline-none py-3 text-[#F3EFE0]"
              data-testid="admin-login-password"
            />
          </div>
          {error && <div className="text-[#C5A059] text-sm border border-[#5C2B29]/40 bg-[#5C2B29]/10 px-4 py-2" data-testid="admin-login-error">{error}</div>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#D4AF37] text-black font-medium px-8 py-4 hover:bg-[#F1C40F] transition-colors disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {submitting ? "Entering…" : "Sign In"}
          </button>
        </form>
        <div className="mt-10 text-xs text-[#6B6A65] border-t border-[#F3EFE0]/10 pt-6">
          Demo credentials: <span className="font-mono text-[#A19D94]">admin@coins.com / admin123</span>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
